//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      passcode: ''
    }
  },
  props: {
    directions: {
      type: String,
      required: false,
      default: 'Enter a passcode in the space below.'
    },
    incorrectMessage: {
      type: String,
      required: false,
      default: undefined
    }
  },
  methods: {
    handleSubmit() {
      if (this.passcode) this.$emit('click', this.passcode)
    }
  }
}
